// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DXMv","colBig":"styles_colBig__1_Gkh","colSmall":"styles_colSmall__5NLmh","shopifyNameWrapper":"styles_shopifyNameWrapper__mwtVC"};